"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withoutLastElement = exports.sortByKey = void 0;
exports.getGlobalScope = getGlobalScope;
exports.dictToArray = dictToArray;
exports.isWebEnvironment = isWebEnvironment;
exports.isWebCryptoAvailable = isWebCryptoAvailable;
exports.isReactNativeEnvironment = isReactNativeEnvironment;
exports.findInArray = findInArray;
exports.searchArray = searchArray;
exports.sureSearchArray = sureSearchArray;
exports.isObject = isObject;
exports.isFunction = isFunction;
exports.isNullOrUndefined = isNullOrUndefined;
exports.isNotUndefined = isNotUndefined;
exports.isEmpty = isEmpty;
exports.isString = isString;
exports.greaterOfTwoDates = greaterOfTwoDates;
exports.uniqCombineObjArrays = uniqCombineObjArrays;
exports.uniqueArray = uniqueArray;
exports.uniqueArrayByKey = uniqueArrayByKey;
exports.lastElement = lastElement;
exports.extendArray = extendArray;
exports.subtractFromArray = subtractFromArray;
exports.removeFromArray = removeFromArray;
exports.addIfUnique = addIfUnique;
exports.filterFromArray = filterFromArray;
exports.arrayByDifference = arrayByDifference;
exports.compareArrayReferences = compareArrayReferences;
exports.compareValues = compareValues;
exports.removeFromIndex = removeFromIndex;
exports.addAtIndex = addAtIndex;
exports.arrayByRemovingFromIndex = arrayByRemovingFromIndex;
exports.objectToValueArray = objectToValueArray;
exports.sortedCopy = sortedCopy;
exports.omitUndefinedCopy = omitUndefinedCopy;
exports.dateSorted = dateSorted;
exports.topLevelCompare = topLevelCompare;
exports.jsonParseEmbeddedKeys = jsonParseEmbeddedKeys;
exports.omitInPlace = omitInPlace;
exports.omitByCopy = omitByCopy;
exports.joinPaths = joinPaths;
exports.Copy = Copy;
exports.deepMerge = deepMerge;
exports.pickByCopy = pickByCopy;
exports.deepFreeze = deepFreeze;
exports.isValidUrl = isValidUrl;
exports.hasGetter = hasGetter;
exports.truncateHexString = truncateHexString;
exports.sleep = sleep;
exports.assertUnreachable = assertUnreachable;
exports.isSameDay = isSameDay;
exports.naturalSort = naturalSort;
exports.arraysEqual = arraysEqual;
exports.convertTimestampToMilliseconds = convertTimestampToMilliseconds;
exports.sanitizeHtmlString = sanitizeHtmlString;
exports.escapeHtmlString = escapeHtmlString;
exports.dateToLocalizedString = dateToLocalizedString;
exports.nonSecureRandomIdentifier = nonSecureRandomIdentifier;
exports.splitString = splitString;
exports.firstHalfOfString = firstHalfOfString;
exports.secondHalfOfString = secondHalfOfString;
exports.log = log;
exports.logWithColor = logWithColor;
exports.assert = assert;
exports.useBoolean = useBoolean;
exports.spaceSeparatedStrings = spaceSeparatedStrings;
exports.pluralize = pluralize;
exports.blobToBase64 = blobToBase64;
/* eslint-disable @typescript-eslint/no-explicit-any */
const dompurify_1 = require("dompurify");
const lodash_1 = require("lodash");
const collator = typeof Intl !== 'undefined' ? new Intl.Collator('en', { numeric: true }) : undefined;
function getGlobalScope() {
    return typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : null;
}
function dictToArray(dict) {
    return Object.values(dict);
}
/**
 * Whether we are in a web browser
 */
function isWebEnvironment() {
    return getGlobalScope() !== null;
}
/**
 * @returns true if WebCrypto is available
 */
function isWebCryptoAvailable() {
    return ((isWebEnvironment() && !isReactNativeEnvironment() && !(document && document.documentMode)) ||
        (/Edge/.test(navigator.userAgent) && window.crypto && !!window.crypto.subtle));
}
/**
 * Whether we are in React Native app
 */
function isReactNativeEnvironment() {
    return typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
}
/**
 * Searches array of objects for first object where object[key] === value
 * @returns Matching object or null if not found
 */
function findInArray(array, key, value) {
    return array.find((item) => item[key] === value);
}
/**
 * Searches array of objects for first object where object[key] === value
 * @returns Matching object or null if not found
 */
function searchArray(array, predicate) {
    return (0, lodash_1.find)(array, predicate);
}
function sureSearchArray(array, predicate) {
    return searchArray(array, predicate);
}
/**
 * @returns Whether the value is a function or object
 */
function isObject(value) {
    if (value === null) {
        return false;
    }
    return typeof value === 'function' || typeof value === 'object';
}
/**
 * @returns Whether the value is a function
 */
function isFunction(value) {
    if (value === null) {
        return false;
    }
    return typeof value === 'function';
}
/**
 * @returns True if the object is null or undefined, otherwise false
 */
function isNullOrUndefined(value) {
    return value === null || value === undefined;
}
function isNotUndefined(val) {
    return val != undefined;
}
/**
 * @returns True if the string is empty or undefined
 */
function isEmpty(string) {
    return !string || string.length === 0;
}
/**
 * @returns Whether the value is a string
 */
function isString(value) {
    return typeof value === 'string' || value instanceof String;
}
/**
 * @returns The greater of the two dates
 */
function greaterOfTwoDates(dateA, dateB) {
    if (dateA > dateB) {
        return dateA;
    }
    else {
        return dateB;
    }
}
/**
 * Returns a new array containing only unique values by combining the two input arrays.
 * Elements are unique based on the values of `equalityKeys`.
 * @param equalityKeys - Keys to determine element equality
 * @returns Array containing unique values
 */
function uniqCombineObjArrays(arrayA, arrayB, equalityKeys) {
    return (0, lodash_1.uniqWith)(arrayA.concat(arrayB), (a, b) => {
        for (const key of equalityKeys) {
            if (a[key] !== b[key]) {
                return false;
            }
        }
        return true;
    });
}
/**
 * Returns a new array containing only unique values
 * @returns Array containing unique values
 */
function uniqueArray(array) {
    return (0, lodash_1.uniq)(array);
}
/**
 * Returns a new array containing only unique values
 * @returns Array containing unique values
 */
function uniqueArrayByKey(array, key) {
    return (0, lodash_1.uniqWith)(array, (a, b) => {
        return a[key] === b[key];
    });
}
/**
 * Returns the last element in the array.
 * @returns The last element in the array
 */
function lastElement(array) {
    return array[array.length - 1];
}
/**
 * Adds all items from otherArray into inArray, in-place.
 * Does not return a value.
 */
function extendArray(inArray, otherArray) {
    for (const value of otherArray) {
        inArray.push(value);
    }
}
/**
 * Removes all items appearing in toSubtract from inArray, in-place
 * @param toSubtract - The list of items to remove from inArray
 */
function subtractFromArray(inArray, toSubtract) {
    for (const value of toSubtract) {
        removeFromArray(inArray, value);
    }
}
/**
 * Removes the first matching element of an array by strict equality.
 * If no matchin element is found, the array is left unchanged.
 */
function removeFromArray(array, value) {
    const valueIndex = array.indexOf(value);
    if (valueIndex === -1) {
        return;
    }
    array.splice(valueIndex, 1);
}
/**
 * Adds the element to the array if the array does not already include the value.
 * The array is searched via array.indexOf
 * @returns true if value was added
 */
function addIfUnique(array, value) {
    if (!array.includes(value)) {
        array.push(value);
        return true;
    }
    return false;
}
/**
 * Removes an object from the array in-place by searching for an object where all the
 * key/values in predicate match with the candidate element.
 */
function filterFromArray(array, predicate) {
    (0, lodash_1.remove)(array, predicate);
}
/**
 * Returns a new array by removing all elements in subtract from array
 */
function arrayByDifference(array, subtract) {
    return array.filter((x) => !subtract.includes(x)).concat(subtract.filter((x) => !array.includes(x)));
}
function compareArrayReferences(arr1, arr2) {
    return arr1.length === arr2.length && arr1.every((val, index) => val === arr2[index]);
}
function compareValues(left, right) {
    if ((left && !right) || (!left && right)) {
        return false;
    }
    if (left instanceof Date && right instanceof Date) {
        return left.getTime() === right.getTime();
    }
    else if (left instanceof String && right instanceof String) {
        return left === right;
    }
    else {
        return topLevelCompare(left, right);
    }
}
/**
 * Removes the value from the array at the given index, in-place.
 */
function removeFromIndex(array, index) {
    array.splice(index, 1);
}
/**
 * Adds the value from the array at the given index, in-place.
 */
function addAtIndex(array, element, index) {
    array.splice(index, 0, element);
}
/**
 * Returns a new array by removeing the value from the array at the given index
 */
function arrayByRemovingFromIndex(array, index) {
    const copy = array.slice();
    removeFromIndex(copy, index);
    return copy;
}
/**
 * Returns an array where each element is the value of a top-level
 * object key.
 * Example: objectToValueArray({a: 1, b: 2}) returns [1, 2]
 */
function objectToValueArray(object) {
    const values = [];
    for (const key of Object.keys(object)) {
        values.push(object[key]);
    }
    return values;
}
/**
 * Returns a key-sorted copy of the object.
 * For example, sortedCopy({b: '1', a: '2'}) returns {a: '2', b: '1'}
 */
function sortedCopy(object) {
    const keys = Object.keys(object).sort();
    const result = {};
    for (const key of keys) {
        result[key] = object[key];
    }
    return Copy(result);
}
const sortByKey = (input, key) => {
    const compare = (a, b) => {
        const valueA = a[key];
        const valueB = b[key];
        if (valueA < valueB) {
            return -1;
        }
        if (valueA > valueB) {
            return 1;
        }
        return 0;
    };
    const newArray = [...input];
    newArray.sort(compare);
    return newArray;
};
exports.sortByKey = sortByKey;
/** Returns a new object by omitting any keys which have an undefined or null value  */
function omitUndefinedCopy(object) {
    const result = {};
    for (const key of Object.keys(object)) {
        if (!isNullOrUndefined(object[key])) {
            result[key] = object[key];
        }
    }
    return result;
}
/**
 * Returns a new array by sorting an array of elements based on a date property,
 * as indicated by the input key value.
 */
function dateSorted(elements, key, ascending = true) {
    return elements.sort((a, b) => {
        const aTimestamp = a[key].getTime();
        const bTimestamp = b[key].getTime();
        const vector = ascending ? 1 : -1;
        if (aTimestamp < bTimestamp) {
            return -1 * vector;
        }
        else if (aTimestamp > bTimestamp) {
            return 1 * vector;
        }
        else {
            return 0;
        }
    });
}
/** Compares for equality by comparing top-level keys value equality (===) */
function topLevelCompare(left, right) {
    if (!left && !right) {
        return true;
    }
    if (!left || !right) {
        return false;
    }
    const leftKeys = Object.keys(left);
    const rightKeys = Object.keys(right);
    if (leftKeys.length !== rightKeys.length) {
        return false;
    }
    for (const key of leftKeys) {
        if (left[key] !== right[key]) {
            return false;
        }
    }
    return true;
}
/**
 * Returns a new object by attempting to JSON.parse any top-level object keys.
 */
function jsonParseEmbeddedKeys(object) {
    const result = {};
    for (const key of Object.keys(object)) {
        let value;
        try {
            value = JSON.parse(object[key]);
        }
        catch (_a) {
            value = object[key];
        }
        result[key] = value;
    }
    return result;
}
const withoutLastElement = (array) => {
    return array.slice(0, -1);
};
exports.withoutLastElement = withoutLastElement;
/**
 * Deletes keys of the input object.
 */
function omitInPlace(object, keys) {
    if (!object) {
        return;
    }
    for (const key of keys) {
        delete object[key];
    }
}
/**
 * Creates a new object by omitting `keys` from `object`
 */
function omitByCopy(object, keys) {
    if (isNullOrUndefined(object)) {
        return undefined;
    }
    const newObject = Object.assign({}, object);
    /**
     * Lodash's omit, which was previously used, seems to cause unexpected behavior
     * when payload is an ES6 item class. So we instead manually omit each key.
     */
    for (const key of keys) {
        delete newObject[key];
    }
    return newObject;
}
/**
 * Similiar to Node's path.join, this function combines an array of paths into
 * one resolved path.
 */
function joinPaths(...args) {
    return args
        .map((part, i) => {
        if (i === 0) {
            return part.trim().replace(/[/]*$/g, '');
        }
        else {
            return part.trim().replace(/(^[/]*|[/]*$)/g, '');
        }
    })
        .filter((x) => x.length)
        .join('/');
}
/**
 * Creates a copy of the input object by JSON stringifying the object then JSON parsing
 * the string (if the input is an object). If input is date, a Date copy will be created,
 * and if input is a primitive value, it will be returned as-is.
 */
function Copy(object) {
    if (object instanceof Date) {
        return new Date(object);
    }
    else if (isObject(object)) {
        return JSON.parse(JSON.stringify(object));
    }
    else {
        return object;
    }
}
/**
 * Merges the second object parameter into the first object, in-place.
 * @returns The now modified first object parameter passed into the function.
 */
function deepMerge(a, b) {
    /**
     * lodash.merge will not merge a full array with an empty one.
     * deepMerge will replace arrays wholesale
     */
    if (!a || !b) {
        throw 'Attempting to deepMerge with null values';
    }
    const customizer = (aValue, bValue) => {
        if ((0, lodash_1.isArray)(aValue)) {
            return bValue;
        }
    };
    (0, lodash_1.mergeWith)(a, b, customizer);
    return a;
}
/**
 * Returns a new object by selecting certain keys from input object.
 */
function pickByCopy(object, keys) {
    const result = {};
    for (const key of keys) {
        result[key] = object[key];
    }
    return Copy(result);
}
/**
 * Recursively makes an object immutable via Object.freeze
 */
function deepFreeze(object) {
    const propNames = Object.getOwnPropertyNames(object);
    for (const name of propNames) {
        const value = object[name];
        if (value && typeof value === 'object' && !Object.isFrozen(value)) {
            object[name] = deepFreeze(value);
        }
        else {
            object[name] = value;
        }
    }
    return Object.freeze(object);
}
function isValidUrl(url) {
    try {
        new URL(url);
        return true;
    }
    catch (_a) {
        return false;
    }
}
/**
 * Determines if an object has a getter defined for a given property
 */
function hasGetter(object, property) {
    const descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(object), property);
    return descriptor && !isNullOrUndefined(descriptor.get);
}
/**
 * Truncates a hex string into a desired number of bits
 * @returns A hexadecimal string truncated to the number of desired bits
 */
function truncateHexString(string, desiredBits) {
    const BITS_PER_HEX_CHAR = 4;
    const desiredCharLength = desiredBits / BITS_PER_HEX_CHAR;
    return string.substring(0, desiredCharLength);
}
/**
 * When awaited, this function allows code execution to pause for a set time.
 * Should be used primarily for testing.
 */
function sleep(milliseconds_1) {
    return __awaiter(this, arguments, void 0, function* (milliseconds, warn = true, desc = '') {
        if (warn) {
            console.warn(`Sleeping for ${milliseconds}ms ${desc}`);
        }
        return new Promise((resolve) => {
            setTimeout(function () {
                resolve();
            }, milliseconds);
        });
    });
}
function assertUnreachable(uncheckedCase) {
    throw Error('Unchecked case ' + uncheckedCase);
}
/**
 * Returns a boolean representing whether two dates are on the same day
 */
function isSameDay(dateA, dateB) {
    return (dateA.getFullYear() === dateB.getFullYear() &&
        dateA.getMonth() === dateB.getMonth() &&
        dateA.getDate() === dateB.getDate());
}
/**
 * Sorts an array of objects in natural order
 * @param items - The array of objects to sort
 * @param property - The objects' property to sort by
 * @param direction - The sorting direction, either ascending (default) or descending
 * @returns Array of objects sorted in natural order
 */
function naturalSort(items, property, direction = 'asc') {
    switch (direction) {
        case 'asc':
            return [...items].sort(collator
                ? (a, b) => collator.compare(a[property], b[property])
                : (a, b) => a[property].localeCompare(b[property], 'en', { numeric: true }));
        case 'desc':
            return [...items].sort(collator
                ? (a, b) => collator.compare(b[property], a[property])
                : (a, b) => b[property].localeCompare(a[property], 'en', { numeric: true }));
    }
}
function arraysEqual(left, right) {
    if (left.length !== right.length) {
        return false;
    }
    return left.every((item) => right.includes(item)) && right.every((item) => left.includes(item));
}
const MicrosecondsInAMillisecond = 1000;
const MillisecondsInASecond = 1000;
var TimestampDigits;
(function (TimestampDigits) {
    TimestampDigits[TimestampDigits["Seconds"] = 10] = "Seconds";
    TimestampDigits[TimestampDigits["Milliseconds"] = 13] = "Milliseconds";
    TimestampDigits[TimestampDigits["Microseconds"] = 16] = "Microseconds";
})(TimestampDigits || (TimestampDigits = {}));
function convertTimestampToMilliseconds(timestamp) {
    const digits = String(timestamp).length;
    switch (digits) {
        case TimestampDigits.Seconds:
            return timestamp * MillisecondsInASecond;
        case TimestampDigits.Milliseconds:
            return timestamp;
        case TimestampDigits.Microseconds:
            return Math.floor(timestamp / MicrosecondsInAMillisecond);
        default:
            throw `Unhandled timestamp precision: ${timestamp}`;
    }
}
function sanitizeHtmlString(html) {
    return (0, dompurify_1.sanitize)(html);
}
function escapeHtmlString(html) {
    return (0, lodash_1.escape)(html);
}
let sharedDateFormatter;
function dateToLocalizedString(date) {
    if (typeof Intl !== 'undefined' && Intl.DateTimeFormat && typeof navigator !== 'undefined') {
        if (!sharedDateFormatter) {
            const locale = navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
            sharedDateFormatter = new Intl.DateTimeFormat(locale, {
                year: 'numeric',
                month: 'short',
                day: '2-digit',
                weekday: 'long',
                hour: '2-digit',
                minute: '2-digit',
            });
        }
        return sharedDateFormatter.format(date);
    }
    else {
        // IE < 11, Safari <= 9.0.
        // In English, this generates the string most similar to
        // the toLocaleDateString() result above.
        return date.toDateString() + ' ' + date.toLocaleTimeString();
    }
}
function nonSecureRandomIdentifier() {
    return `${Math.random() * 100}`.replace('.', '');
}
function splitString(string, parts) {
    const outputLength = string.length;
    const partLength = outputLength / parts;
    const partitions = [];
    for (let i = 0; i < parts; i++) {
        const partition = string.slice(partLength * i, partLength * (i + 1));
        partitions.push(partition);
    }
    return partitions;
}
function firstHalfOfString(string) {
    return string.substring(0, string.length / 2);
}
function secondHalfOfString(string) {
    return string.substring(string.length / 2, string.length);
}
function log(namespace, ...args) {
    logWithColor(namespace, 'black', ...args);
}
function logWithColor(namespace, namespaceColor, ...args) {
    const date = new Date();
    const timeString = `${date.toLocaleTimeString().replace(' PM', '').replace(' AM', '')}.${date.getMilliseconds()}`;
    customLog(`%c${namespace}%c${timeString}`, `color: ${namespaceColor}; font-weight: bold; margin-right: 4px`, 'color: gray', ...args);
}
function customLog(..._args) {
    // eslint-disable-next-line no-console, prefer-rest-params
    Function.prototype.apply.call(console.log, console, arguments);
}
function assert(value) {
    if (value === undefined) {
        throw new Error('Assertion failed; value must be defined');
    }
}
function useBoolean(value, defaultValue) {
    return value != undefined ? value : defaultValue;
}
function spaceSeparatedStrings(...strings) {
    return strings.join(' ');
}
function pluralize(count, singular, plural) {
    return count === 1 ? singular : plural;
}
function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            if (reader.result && typeof reader.result === 'string') {
                resolve(reader.result);
            }
            else {
                reject();
            }
        };
        reader.readAsDataURL(blob);
    });
}
